import React from "react";

export default function SolarTuningLineDuotone(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.2em"
      height="1.2em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M10 9.5a3 3 0 1 1-6 0a3 3 0 0 1 6 0Zm10 5a3 3 0 1 0-6 0a3 3 0 0 0 6 0Z"></path>
        <path
          strokeLinecap="round"
          d="m17 11l.041-9M7 2v4m0 7v9m10 0v-4"
          opacity={0.5}
        ></path>
      </g>
    </svg>
  );
}
